import React from "react";
import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "../components/blog.css";
import blogData from "../data/BlogData";
import FAQ from "../components/NewFAQ";
import ZohoLeadForm from "../Extra/ZohoLeadForm";
import BlogSidebarLeadForm from "../components/BlogSidebarLeadForm";


const BlogDetail = () => {
  const { slug } = useParams();
  const blog = blogData.find((item) => item.slug === slug);

  if (!blog) return <h2>Blog not found</h2>;

  //   useEffect(() => {
  //   const path = window.location.pathname;
  //   if (!path.endsWith("/")) {
  //     window.location.replace(path + "/" + window.location.search);
  //   }
  // }, []);


  const subtitles = Object.keys(blog)
    .filter((key) => key.startsWith("subtitle"))
    .map((key) => blog[key]);

  return (
    <>
      <div
        className="inner-banner"
        style={{
          background: `url(${blog.image}) center center no-repeat`,
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row inner-title text-center">
            <div className="col-lg-6">
              <div className="about-widget-img breadcrumb-itd">
                <h3>{blog.title}</h3>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>
                  </li>
                  <li>
                    <Link to="/blog">Blog</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>
                  </li>
                  <li>{blog.title}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-detail container">
        <div className="row">
          <div className="col-lg-3 col-md-4 d-none d-md-block">
            {/* <BlogSidebarLeadForm /> */}
            <div className="toc-box">
              <h5 className="toc-title">Table Of Contents</h5>
              <ol>
                <li><a href="#introduction">Introduction</a></li>

                {subtitles.map((item, index) => (
                  <li key={index}>
                    <a href={`#section-${index}`}>{item.h1}</a>
                  </li>
                ))}

                {blog.finalPerspective && (
                  <li><a href="#conclusion">Final Perspective</a></li>
                )}
              </ol>
            </div>
          </div>

          <div className="col-lg-9 col-md-8 col-12">
            <h3 className="blog-title">{blog.title}</h3>
            {/* <div className="d-block d-md-none">
              <BlogSidebarLeadForm />
            </div> */}

            <div className="blog-content">

              {/* MOBILE TOC */}
              <div className="toc-box d-block d-md-none mb-3">
                <h5 className="toc-title">Table Of Contents</h5>
                <ol>
                  <li><a href="#introduction">Introduction</a></li>

                  {subtitles.map((item, index) => (
                    <li key={index}>
                      <a href={`#section-${index}`}>{item.h1}</a>
                    </li>
                  ))}

                  {blog.finalPerspective && (
                    <li><a href="#conclusion">Final Perspective</a></li>
                  )}
                </ol>
              </div>

              {/* INTRODUCTION */}
              <h5 id="introduction">Introduction</h5>
              {blog.content1 && <p>{blog.content1}</p>}
              {blog.content2 && <p>{blog.content2}</p>}
              {blog.content3 && <p>{blog.content3}</p>}

              {subtitles.map((item, index) => (
                <div key={index}>
                  <h5 id={`section-${index}`}>{item.h1}</h5>
                  <p>{item.p}</p>
                  {item.p2 && <p>{item.p2}</p>}
                </div>
              ))}

              {blog.finalPerspective && (
                <>
                  <h4 id="conclusion">{blog.finalPerspective.h1}</h4>
                  <p>{blog.finalPerspective.p}</p>
                  <p>{blog.finalPerspective.p2}</p>
                </>
              )}
            </div>
            <FAQ faqKey="hospital" />
          </div>
        </div>
      </div>


      {/* <FAQ faqKey="hospital" /> */}
    </>
  );
};

export default BlogDetail;
